import React from 'react';
import { DevicesDataProvider } from '../../../data/DataProviders/DevicesDataProvider';
import { DeviceGroups } from '../../../components/DeviceGroups';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { LocationsDropdownToolbar } from '../../../components/LocationsDropdownToolbar/LocationsDropdownToolbar';
import { useSelectedLocationData, isRecordFound } from '../../../hooks/data-hooks';
import { ContentContainer } from '../../../components/ContentContainer';
import { RecordDataIndicators } from '../../../components/RecordDataIndicators';
import { useAppRoute } from '../../../hooks/app-route-hooks';

export const DevicesLocation: React.FC = () => {
    const currentAppRoute = useAppRoute('DevicesLocation');
    const selectedLocationData = useSelectedLocationData();
    const { t } = useLanguageLocale();
    return (
        <>
            <LocationsDropdownToolbar title={t('DASHBOARD.DEVICES_TITLE')} />

            <ContentContainer testId="location-devices">
                <RecordDataIndicators
                    recordData={selectedLocationData}
                    errorMessage={t('DASHBOARD.ERROR_LOADING_LOCATION')}
                    notFoundIcon="LocationCity"
                    notFoundMessage={t('DASHBOARD.LOCATION_NOT_FOUND')}
                />

                {isRecordFound(selectedLocationData) && (
                    <DevicesDataProvider locationId={selectedLocationData.value.id}>
                        <DeviceGroups
                            deviceDetailAppRoute={{
                                type: 'DevicesLocationDeviceDetails',
                                deviceId: '--',
                                locationId: currentAppRoute.locationId,
                            }}
                        />
                    </DevicesDataProvider>
                )}
            </ContentContainer>
        </>
    );
};
